import axios from "axios";
export const baseURL = "https://labsystems.cubez.cloud/api/";
const api = axios.create({ baseURL: baseURL });

export default api;
